import { ITypedReduxAction } from '../../types/redux/actionType';

export enum ESearchQueryActionType {
  SetSearchQuery = 'searchQuery/setSearchQuery',
}

export type TSetSearchQuery = ITypedReduxAction<ESearchQueryActionType.SetSearchQuery, string>;

export type TSearchQueryActions = TSetSearchQuery;
